// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2tpSA","container":"LayoutSideNavigation_container__1h6D6","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2O1kb"};